module.exports = __webpack_public_path__ + "media/images/theodor_herzl_award/logo-bg-white-f92793d402ae6ead90d8a1e760a4799b.svg";